import { create } from "zustand";

interface CaseState {
  caseId: string | null;
  setCaseId: (caseId: string | null) => void;
  debtConsolidationFormSubmitted: boolean;
  setDebtConsolidationFormSubmitted: (
    debtConsolidationFormSubmitted: boolean,
  ) => void;
}

export const useCaseStore = create<CaseState>()((set, get) => ({
  caseId: null,
  debtConsolidationFormSubmitted: false,

  setCaseId: (caseId) => set(() => ({ caseId })),
  setDebtConsolidationFormSubmitted: (debtConsolidationFormSubmitted) =>
    set(() => ({
      debtConsolidationFormSubmitted,
    })),
}));
